import ServiceEndpoints from "../ServiceEndpoints";
import {SearchScenariosResult} from "../../model/SearchScenariosResult";
import {POISearchScenario} from "../../model/POISearchScenario";
import {HTTP_STATUS_INTERNAL_SERVER_ERROR} from "../../constants/HttpStatusCodes";

export async function fetchNaturalSearchScenarios(naturalForm: any, userToken?: string): Promise<SearchScenariosResult> {
    return await fetch(ServiceEndpoints.FetchNaturalSearchScenarios,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(naturalForm)
        })
        .then( async (resp) => {
            if (resp.ok) {
                return await resp.json() as SearchScenariosResult;
            } else {
                return new SearchScenariosResult();
            }
        })
        .catch((error) => {
            console.error(error);
            return new SearchScenariosResult();
        });
}

export async function fetchLegalSearchScenarios(legalForm: any, userToken?: string): Promise<SearchScenariosResult> {
    return await fetch(ServiceEndpoints.FetchLegalSearchScenarios,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(legalForm)
        })
        .then( async (resp) => {
            if (resp.ok) {
                return await resp.json() as SearchScenariosResult;
            } else {
                return new SearchScenariosResult();
            }
        })
        .catch((error) => {
            console.error(error);
            return new SearchScenariosResult();
        });
}

export async function addSearchScenario(newScenarioForm: POISearchScenario, userToken?: string): Promise<number> {
    return await fetch(ServiceEndpoints.AddSearchScenario,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(newScenarioForm)
        })
        .then( async (resp) => {
            return resp.status;
        })
        .catch((error) => {
            console.error(error);
            return HTTP_STATUS_INTERNAL_SERVER_ERROR;
        });
}

export async function editSearchScenario(editScenarioForm: POISearchScenario, userToken?: string): Promise<number> {
    return await fetch(ServiceEndpoints.EditSearchScenario,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(editScenarioForm)
        })
        .then( async (resp) => {
            return resp.status;
        })
        .catch((error) => {
            console.error(error);
            return HTTP_STATUS_INTERNAL_SERVER_ERROR;
        });
}

export async function deleteSearchScenario(deleteScenarioForm: POISearchScenario, userToken?: string): Promise<boolean> {
    return await fetch(ServiceEndpoints.DeleteSearchScenario,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(deleteScenarioForm)
        })
        .then( async (resp) => {
            return resp.ok;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}